import client from 'enrollment-platform/api/eps.client'
import { PaginationResponse } from 'enrollment-platform/types/pagination-response-dto'
import {
  CensusRunDto,
  CensusRunQueryParams,
  CensusRunStepDto,
  CensusSnapshotDownloadDto,
  CensusSnapshotPreviewDto,
  CensusTraceDto,
} from './types'

const CENSUS_RUNS_ENDPOINT = '/api/v1/census-runs'

export const getCensusRuns = async (
  params: CensusRunQueryParams
): Promise<PaginationResponse<CensusRunDto>> => {
  const response = await client.get<PaginationResponse<CensusRunDto>>(
    CENSUS_RUNS_ENDPOINT,
    { params }
  )
  return response.data
}

export const getCensusRunSteps = async (
  runId: string
): Promise<CensusRunStepDto[]> => {
  const response = await client.get<CensusRunStepDto[]>(
    `${CENSUS_RUNS_ENDPOINT}/${runId}/steps`
  )
  return response.data
}

/**
 * A short-lived link to one snapshot. The URL is fetched only when an admin
 * asks for the file, so a link is never sitting in the page waiting to leak.
 */
export const getCensusSnapshotUrl = async (
  runId: string,
  stepKey: string,
  file: string
): Promise<CensusSnapshotDownloadDto> => {
  const response = await client.get<CensusSnapshotDownloadDto>(
    `${CENSUS_RUNS_ENDPOINT}/${runId}/snapshots/${encodeURIComponent(
      stepKey
    )}/${encodeURIComponent(file)}`
  )
  return response.data
}

/** The rows of a snapshot, for reading on screen rather than downloading. */
export const getCensusSnapshotPreview = async (
  runId: string,
  stepKey: string,
  file: string
): Promise<CensusSnapshotPreviewDto> => {
  const response = await client.get<CensusSnapshotPreviewDto>(
    `${CENSUS_RUNS_ENDPOINT}/${runId}/snapshots/${encodeURIComponent(
      stepKey
    )}/${encodeURIComponent(file)}/preview`
  )
  return response.data
}

/** Where one person appears in the row snapshots of a run. */
export const getCensusRunTrace = async (
  runId: string,
  name: { firstName?: string; lastName?: string }
): Promise<CensusTraceDto> => {
  const response = await client.get<CensusTraceDto>(
    `${CENSUS_RUNS_ENDPOINT}/${runId}/trace`,
    { params: name }
  )
  return response.data
}
